import { isObjectNotEmpty, isStringEmpty, isStringNotEmpty } from "../utils/objectUtils";
import { toE164PhoneNumber } from "../utils/stringFormatter";
import { isValidStateAbbreviation, isValid5or9ZipCode, isValid3LetterCountryCode } from "../utils/validationUtils";

class Address {
    firstName = null;
    lastName = null;
    company = null;
    streetAddress1 = null;
    streetAddress2 = null;
    city = null;
    state = null;
    postalCode = null;
    country = null;
    phone = null;

    constructor(address) {
        if (isObjectNotEmpty(address)) {
            if (isStringNotEmpty(address.firstName)) { this.firstName = address.firstName.trim(); }
            if (isStringNotEmpty(address.lastName)) { this.lastName = address.lastName.trim(); }
            if (isStringNotEmpty(address.company)) { this.company = address.company.trim(); }
            if (isStringNotEmpty(address.streetAddress1)) { this.streetAddress1 = address.streetAddress1.trim(); }
            if (isStringNotEmpty(address.streetAddress2)) { this.streetAddress2 = address.streetAddress2.trim(); }
            if (isStringNotEmpty(address.city)) { this.city = address.city.trim(); }
            if (isStringNotEmpty(address.state)) { this.state = address.state; }
            if (isStringNotEmpty(address.postalCode)) { this.postalCode = address.postalCode.trim(); }
            if (isStringNotEmpty(address.country)) { this.country = address.country; }
            if (isStringNotEmpty(address.phone)) { this.phone = toE164PhoneNumber(address.phone); }
        }
    }

    toDto = () => {
        return {
            firstName: this.firstName,
            lastName: this.lastName,
            company: this.company,
            streetAddress1: this.streetAddress1,
            streetAddress2: this.streetAddress2,
            city: this.city,
            state: this.state,
            postalCode: this.postalCode,
            country: this.country,
            phone: this.phone,
        };
    }

    isValid = () => {
        if (isStringEmpty(this.streetAddress1)) {
            throw new Error('Street Address Line 1 is required.');
        }
        if (isStringEmpty(this.city)) {
            throw new Error('City is required.');
        }
        if (isStringEmpty(this.state) || !isValidStateAbbreviation(this.state)) {
            throw new Error('State is required and must be a valid 2 letter state abbreviation.');
        }
        if (isStringEmpty(this.postalCode) || !isValid5or9ZipCode(this.postalCode)) {
            throw new Error('Postal code is required and must be a valid 5 digit or 9 digit postal code.');
        }
        if (isStringEmpty(this.country) || !isValid3LetterCountryCode(this.country)) {
            throw new Error('Country is required and must be a valid 3 letter country code.');
        }

        return true;
    }
};

export default Address;